require('../../common/directives/jv.TriggerOnView.Directive');
require('../../common/directives/jv.HideOnBlur');

angular.module('jv.Dashboard.Directive', [
    'jv.TriggerOnView.Directive',
    'jv.Common.Directives.HideOnBlur'
])
.directive('jvDashboardDirective', ['$http', '$q', '$log', '$timeout', '$compile', '$window', 'TemplateLoader', 'Loading', 'jvDashboardFactory','$rootScope', '$jobviteUrls', 'jvDashboardAjaxService',
    function ($http, $q, $log, $timeout, $compile, $window, TemplateLoader, Loading, jvDashboardFactory, $rootScope, $jobviteUrls, jvDashboardAjaxService) {
        var directiveDefinitionObject = {
            require: 'ngModel',
            scope: {
                jvDashboardConfig: "=jvDashboardDirective"
            },
            controller: ['$scope', '$element', function ($scope, $element) {
                $scope.dashboardLoaded = false;
                $scope.showWidgetSettings = false;
                $scope.defaultDashboard = true;
                $scope.enableDashboardTitleEdit = false;
                $scope.sharedObject = {
                    validationApproved: false,
                }

                var state = $scope.state = {
                    dataSourceSelected: true,
                    settingsSelected: false,
                }

                if($scope.jvDashboardConfig.defaultDashboard === false) {
                    $scope.defaultDashboard = false;
                }

                if(window.isnextGenUIEnabled == 'true') {
                    $scope.jvDashboardConfig.margins = [25, 25];
                } else {
                    $scope.jvDashboardConfig.margins = [10, 10];
                }

                $scope.dashboardKind = $scope.jvDashboardConfig.dashboardKind;

                var setDrag = function(val){
                    jvDashboardFactory.saveDashboardConfigDrag(val);
                };

                var hideWidgetSettings = function() {
                    $scope.showWidgetSettings = false;
                    setDrag(false);
                };

                var showwidgetSettings = function(){
                    $scope.showWidgetSettings = true;
                    setDrag(true);
                };

                var updateGA = function(event) {
                    if(typeof _gaq != "undefined" && JV.PAGE_TYPE) {
                      _gaq.push(['_trackEvent', JV.PAGE_TYPE, event, $window._jvselfUser.companyEId]);
                    }
                };

                //Settings modal config
                $scope.modals = {
                    dashboardSettings : {
                        show: false
                    },
                    widgetList: {
                        show: false
                    },
                    dashboardWarning: {
                        show: false
                    },
                    dashboardDeleteWarning: {
                        show: false
                    },
                    editDashboardName: {
                        show: false
                    },
                    dashboardClone: {
                        show: false
                    }
                };

                //modal templates
                $scope.templates = TemplateLoader.register({
                    dashboardSettings: '/admin/myaccount/dashboard/dashboardSettings.html',
                    dashboardWarning: '/admin/myaccount/dashboard/dashboardWarning.html',
                    dashboardDeleteWarning: '/admin/myaccount/dashboard/dashboardDeleteWarning.html',
                    editDashboardName: '/admin/myaccount/dashboard/editDashboardName.html',
                    widgetList: '/admin/myaccount/dashboard/widgetList.html',
                    dashboardClone: '/admin/myaccount/dashboard/dashboardClone.html'
                });

                //show modal
                var showModal = function(modal){
                    TemplateLoader.load(modal).then(function(){
                        $scope.modals[modal].show = true;
                    });
                };
                //hide modal
                $scope.hideModal = function(modal){
                    $scope.settingsObject = {};
                    $scope.modals[modal].show = false;
                    $scope.selectDataSources();
                };

                //cancel while adding a new widget
                $scope.backToWidgetList = function(){
                    $scope.selectDataSources();
                    $scope.hideModal('dashboardSettings');
                    showModal('widgetList');
                    //reset $scope.newWidget since user hit cancel
                    $scope.newWidget = {};
                };

                var updateWidgetSettings = function(widgetObject, userValuesArray){
                    widgetObject.userWidgetSettings.widgetSetting = angular.copy(userValuesArray);
                };

                var massageUserValues = function(userValues){
                    angular.forEach(userValues,function(userValueObject,key){
                        var userValueProperty = 'userValues';
                        if (userValueObject.subWidgetSettingUserValues) {
                            userValueProperty = 'subWidgetSettingUserValues';
                            userValueObject[userValueProperty] = massageUserValues(userValueObject[userValueProperty]);
                        } else {
                            angular.forEach(userValueObject[userValueProperty],function(userValue,index){
                                if( angular.isObject(userValue.label) && userValue.label.EId){
                                    userValue.EId = userValue.label.EId;
                                }

                                //Added for HM use case. Need to fix this.
                                if(userValue.fullName){
                                    userValue.label = userValue.fullName;
                                }

                                //Added for Posting Type
                                if (userValue.index != undefined && userValue.index != null) {
                                    userValue.value = userValue.index;
                                }

                                //remove the empty label values Fix for IIBN-952 : NV
                                if(Object.keys(userValue).length  === 1 && userValue.label === null){
                                    delete userValueObject[userValueProperty];
                                }
                                /*If label is null and value is present user has cleared the drop down and in that case we set the drop down value to select an option which needs to be translated , hence send a name attribute to BE
                                which will get resolved into the label attribute when the backend sends this back to the UI */
                                if(userValue.value && userValue.label === null){
                                    userValue.createdByCode = true;
                                    userValue.label = i18n['SELECT_AN_OPTION'];
                                    userValue.name = "SELECT_AN_OPTION";
                                    delete userValue.value;
                                }
                                /*if both label and value are present then user has selected an option from the dropdown so we dont need to translate that uservalue
                                    This applies for only ajax calls where we dont need to translate the values because user may have enterted the list themselves.
                                    values for non ajax calls are driven by enums in the backend that need to be translated.
                                */
                                if(userValue.value && userValue.label && !userValueObject.settings.values && userValueObject.settings.viewFieldDataType !== 'MultiSelect'){
                                    delete userValue.name;
                                }
                            });
                        }

                    });
                    return userValues;
                };

                $scope.$on('DASHBOARD_LOADED', function() {
                    $scope.dashboardLoaded = true;
                });
                //listner for dashboard config
                $rootScope.$on('DASHBOARD_CONFIG_UPDATED', function() {
                    $scope.widgets = jvDashboardFactory.getWidgets();
                });

                $rootScope.$on('DASHBOARD_UPDATED', function() {
                    Loading.dequeue();
                    $scope.$emit('showMessageBar', i18n['DASHBOARD_SETTINGS_SAVED']);
                });

                $scope.widgets = jvDashboardFactory.getWidgets();

                //used to put dashboard title in edit mode
                $scope.enableTitleEdit = function(){
                    $scope.enableDashboardTitleEdit = true;
                };
                $scope.disableTitleEdit = function(){
                    $scope.enableDashboardTitleEdit = false;
                }
                //When cancel is invoked
                $scope.cancelSettings = function(){
                    $scope.disableTitleEdit();
                    if (jvDashboardFactory.hasDashboardChanged($scope.widgets, $scope.widgetsCopy)) {
                        $scope.warningModal = {};
                        $scope.warningModal.unsavedChanges = true;
                        showModal('dashboardWarning');
                    } else {
                        $scope.cancelSettingsProceed();
                    }
                    $scope.newDashboardClicked = false;
                };

                $scope.addWidgetsForDashboard = function(){
                    $scope.enableSettingsMode();
                    $scope.showWidgets();

                };

                $scope.switchUserDashboard = function(dashboard){
                    $window.location.href = $jobviteUrls.admin + "/myaccount/dashboard.html?id=" + dashboard.dashboardId;
                };

                $scope.getUserDashboards= function(){
                    Loading.queue();
                    jvDashboardAjaxService.getUserDashboards({}, function(response){
                        if(response && response.userDashboards){
                            $scope.userDashboards = response.userDashboards;
                            $scope.toggleDropDown();
                            Loading.dequeue();
                        }
                    });
                };

                $scope.toggleDropDown = function(){
                    $scope.dropDownVisible = !$scope.dropDownVisible;
                };

                $scope.nameDashboard = function(){
                    $scope.warningModal = {};
                    $scope.warningModal.nameDashboard = true;
                    $scope.newDashboardTitle = '';
                    showModal('editDashboardName');
                };

                $scope.addDashboard = function(newDashboardTitle){
                    updateGA("addDashboard");
                    var postData = {
                        'dashboardTitle': newDashboardTitle
                    };
                    jvDashboardAjaxService.createNewDashboard(postData, function(response){
                        $window.location.href = $jobviteUrls.admin + "/myaccount/dashboard.html?id=" + response.dashboardId;
                    });
                };

                $scope.showDeleteDashboard = function(widget) {
                    $scope.warningModal = {};
                    $scope.warningModal.deleteDashboard = true;
                    showModal('dashboardDeleteWarning');
                };

                $scope.deleteDashboard = function(){
                    updateGA("deleteDashboard");
                    var dashboardId = $scope.jvDashboardConfig.dashboardId;
                    jvDashboardAjaxService.deleteDashboard({'id': dashboardId}, function(response){
                        $window.location.href = $jobviteUrls.admin + "/myaccount/dashboard.html";
                    });
                };

                $scope.cancelSettingsProceed = function() {
                    updateGA("cancelSettings");
                    //resetting the widgets on the dashboard on cancel
                    //Added a condition to avoid unnecessary gridster reload if any changes are not done.
                    if(jvDashboardFactory.hasDashboardChanged($scope.widgets, $scope.widgetsCopy)) {
                        jvDashboardFactory.resetDashboardWidgets($scope.widgetsCopy);
                    }
                    if($scope.newWidget){
                        jvDashboardFactory.resetWidgetInstanceMap();
                    }
                    hideWidgetSettings();
                    $scope.warningModal = {};
                    $scope.hideModal('dashboardWarning');
                };

                //go into edit mode
                $scope.enableSettingsMode = function(){
                    updateGA("editSettingsMode");
                    showwidgetSettings();
                    // Updated the condition to copy the data if there has been any modification in the widgets
                    if( $.isEmptyObject($scope.widgetsCopy) || (!$.isEmptyObject($scope.widgetsCopy) && jvDashboardFactory.hasDashboardChanged($scope.widgets, $scope.widgetsCopy)) ){
                        $scope.widgetsCopy = angular.copy($scope.widgets);
                    }
                };

                //called when widget library is clicked
                $scope.showWidgets = function(){
                    updateGA("addWidgetsLibrary");
                    showModal('widgetList');
                };

                //Handler to showing the widget settings modal
                $rootScope.$on('DASHBOARD_SHOW_SETTINGS_MODAL', function(event,widgetData) {
                    if(widgetData){
                        $scope.hideModal('widgetList');
                        //reset $scope.newWidget
                        $scope.newWidget = {};
                        $scope.newWidget = widgetData;
                        $scope.newWidget.templateSelected = angular.isDefined(widgetData.templateSelected) ? widgetData.templateSelected: true;
                        $scope.editSettings($scope.newWidget);
                    }
                });

                //Called when edit settings is invoked.
                $scope.editSettings = function(widget){
                    if(widget) {
                        updateGA('editSettings-' + widget.mainType);
                        $scope.settingsObject = widget.userWidgetSettings;
                        showModal('dashboardSettings');
                        $scope.widgetObject = widget;
                    }
                };

                $scope.showTemplates = function() {
                    if ($scope.widgetObject.templates && $scope.widgetObject.templateSelected) {
                        return true;
                    }
                    return false;
                }

                $scope.selectTemplate = function(template) {
                    if (!template.blank) {
                        $scope.settingsObject.widgetSetting = template.widgetSettings;
                    } else{
                        $scope.settingsObject = $scope.widgetObject.userWidgetSettings;
                    }
                    $scope.widgetObject.templateSelected = false;
                    $scope.selectDataSources();
                }

                $scope.isWizardSettings = function() {
                    if ($scope.widgetObject.mainType === 'ApplicationAnalytics' || $scope.widgetObject.mainType === 'RequisitionAnalytics') {
                        return true;
                    } else {
                        return false;
                    }
                };

                $scope.dataSourceSelected = function() {
                    return state.dataSourceSelected;
                };

                $scope.selectDataSources = function() {
                    state.dataSourceSelected = true;
                    state.settingsSelected = false;
                };

                $scope.selectSettings = function(viewFields) {
                    state.settingsSelected = true;
                    state.dataSourceSelected = false;
                    $scope.settingsObject.widgetSetting = viewFields;
                }

                $scope.settingsSelected = function() {
                    return state.settingsSelected;
                };

                var updateGAApplySettings = function(userValues) {
                    if ($scope.widgetObject) {
                        if ($scope.widgetObject.subType === 'ApplicationAnalytics'
                            || $scope.widgetObject.subType === 'RequisitionAnalytics') {
                            var level2 = false;
                            angular.forEach(userValues, function(field) {
                                if (field && field.settingType === 'GroupByLevel2') {
                                    if (field.subWidgetSettingUserValues
                                        && field.subWidgetSettingUserValues[0]
                                        && field.subWidgetSettingUserValues[0].subWidgetSettingUserValues) {
                                        level2 = true;
                                    }
                                }
                            });
                            if (level2) {
                                updateGA('editSettingsApply-'+$scope.widgetObject.subType+'-Level2');
                            } else {
                                updateGA('editSettingsApply-'+$scope.widgetObject.subType+'-Level1');
                            }
                        } else {
                            updateGA('editSettingsApply-'+$scope.widgetObject.subType);
                        }
                    }
                };

                //apply filter for widget
                $scope.applySettings = function(userValues){
                    userValues = massageUserValues(userValues);
                    updateGAApplySettings(userValues);
                    userValues.filter(jvDashboardFactory.filterPostData);
                    if( !$.isEmptyObject ($scope.newWidget) ){
                        $scope.emptyDashboard = false;
                        var newlyAddedWidget =  angular.copy($scope.newWidget);
                        //update widget instance for newly added widget
                        jvDashboardFactory.updateWidgetInstance(newlyAddedWidget.mainType, true);
                        updateWidgetSettings(newlyAddedWidget,userValues);
                        //add new widget to the layout
                        jvDashboardFactory.addWidgetToLayout(newlyAddedWidget);
                    }
                    updateWidgetSettings($scope.widgetObject,userValues);
                    $scope.refreshWidget($scope.widgetObject, true, $scope.newWidget);
                    jvDashboardFactory.resolveWidgetTitle($scope.widgets);
                    //reset $scope.newWidget
                    $scope.newWidget = {};
                    $scope.selectDataSources();
                    //hide modals
                    $scope.hideModal('dashboardSettings');
                };

                //Called when edit settings is invoked.
                $scope.refreshWidget = function(widget, settingsUpdated, newWidget){
                    if(widget) {
                        updateGA("forceRefresh");
                        //If a new widget is created update the newlyAddedWidgetsMap in the factory
                        if(! $.isEmptyObject(newWidget)){
                            //Need to store this in the factory because the controller gets re initialized when you create a new widget so setting refresh = true here will be lost when the controller reloads for the newly added wiget.
                            jvDashboardFactory.updateNewlyAddedWidgetsMap(newWidget);
                        }
                        //widget.settingsUpdated = settingsUpdated || false;
                        $rootScope.$emit('REFRESH_WIDGET',widget);
                    }
                };

                $scope.deleteWidget = function(widget) {
                    $scope.warningModal = {};
                    $scope.warningModal.deleteWidget = true;
                    $scope.warningModal.widget = widget;
                    showModal('dashboardWarning');
                };


                var canWidgetBeCloned = function(widget) {
                    if (widget.widget.maximum === jvDashboardFactory.getWidgetInstance(widget.mainType)) {
                        return false;
                    } else {
                        return true;
                    }
                };

                $scope.cloneWidget = function(widget) {
                    updateGA('cloneWidget');
                    widget.templateSelected = false;
                    if (canWidgetBeCloned(widget)) {
                        var widgetObject = angular.copy(widget);
                        delete widgetObject.widgetId;
                        if(widgetObject){
                            angular.forEach(widgetObject.userWidgetSettings.widgetSetting,function(settingsObject){
                                if(settingsObject.settings.fieldType ==='Text' && settingsObject.settings.objectType === 'Title'){
                                    if (settingsObject.userValues) {
                                        settingsObject.userValues[0].label = settingsObject.userValues[0].label + ' [' + i18n.CLONED + ']';
                                    } else {
                                        settingsObject.userValues = [];
                                        settingsObject.userValues[0] = settingsObject.settings.defaultValues[0];
                                        settingsObject.userValues[0].label = settingsObject.userValues[0].label + ' [' + i18n.CLONED + ']';
                                    }
                                }
                            });
                        }
                        $rootScope.$emit('DASHBOARD_SHOW_SETTINGS_MODAL',widgetObject);
                    } else {
                        showModal('dashboardClone');
                    }
                };

                $scope.deleteWidgetProceed = function() {
                    $scope.hideModal('dashboardWarning');
                    jvDashboardFactory.updateWidgetInstance($scope.warningModal.widget.mainType, false);
                    jvDashboardFactory.deleteWidget($scope.warningModal.widget);
                    $scope.warningModal = {};
                };

                $scope.canWidgetBeDeleted = function(widget) {
                    if (widget.widget.minimum === jvDashboardFactory.getWidgetInstance(widget.mainType)) {
                        return false;
                    } else {
                        return true;
                    }
                };

                //save user dashboard
                $scope.saveSettings = function(){
                    $scope.disableTitleEdit();
                    updateGA("settingsSaved");
                    Loading.queue();
                    var userDashboardTitle = angular.copy($scope.jvDashboardConfig.userDashboardTitle);
                    jvDashboardFactory.setUserDashboardTitle(userDashboardTitle);
                    hideWidgetSettings();
                    jvDashboardFactory.saveUserDashboard($scope.widgets, $scope.widgetsCopy,userDashboardTitle);
                    $scope.widgetsCopy = angular.copy($scope.widgets);
                };

                $scope.addWidget = function(widgetObject) {
                    updateGA("widgetAdded-" + widgetObject.mainType);
                    jvDashboardFactory.addWidget(widgetObject.mainType);
                };

                if(jvDashboardFactory.getUserDashboard().userWidgets.length === 0){
                    //new dashboard loaded
                    $scope.emptyDashboard = true;

                    //when new dashboard is loaded put it in settings mode and also open the add widgets modal
                    $scope.enableSettingsMode();
                    $scope.showWidgets();
                 }
            }],
            templateUrl: 'dashboard/dashboardTemplate.html',
            replace: true,
            transclude: true
        };
        return directiveDefinitionObject;
    }]);
